import PortalClienteDBService from "./bases/PortalClienteDBService";

class TermosAceiteService extends PortalClienteDBService{
    async ListarTermosAceite(){
        return await this.get(`portaldb/TermoAceite/ListarTermosParaAceite`)
    }
    
    async AceitarTermoAceite(data){;
        return await this.post(`portaldb/TermoAceite/Aceitar`, JSON.stringify(data))
    }
}

export default new TermosAceiteService();